import React, { useState, useRef, useEffect } from "react";
import { Link } from "react-router-dom";
import { CaretDown, ArrowUpRight } from "@phosphor-icons/react";

/**
 * Aegis One - top nav mega menu.
 */

const MENUS = {
    Products: {
        width: 640,
        columns: [
            {
                title: "Core",
                items: [
                    { k: "Miner Terminal", d: "Buy hashrate · earn AONE",   to: "/miner" },
                    { k: "Aegis Wallet",   d: "USDT deposits + AONE",       to: "/wallet" },
                    { k: "Withdraw USDT",  d: "Send USDT to any wallet",    to: "/wallet/withdraw" },
                    { k: "Swap",           d: "AONE ⇄ USDT liquidity",       to: "/swap" },
                    { k: "Referrals",      d: "Earn 10% on every referral",  to: "/referrals" },
                ],
            },
            {
                title: "Network",
                items: [
                    { k: "Validators", d: "Global validator set",    to: "/validators" },
                    { k: "Tokenomics", d: "10B AONE distribution",   to: "/tokenomics" },
                ],
            },
        ],
    },
    Network: {
        width: 520,
        columns: [
            {
                title: "Learn",
                items: [
                    { k: "How Mining Works",  d: "Hashrate → AONE rewards",   to: "/miner" },
                    { k: "Cross-chain USDT",  d: "Deposit from any chain",    to: "/wallet/deposit" },
                    { k: "Validator Set",     d: "Live network participants", to: "/validators" },
                ],
            },
        ],
    },
    Company: {
        width: 480,
        columns: [
            {
                title: "About",
                items: [
                    { k: "About AONE",  d: "Electrical Predictive Failure AI", to: "/" },
                    { k: "Tokenomics",  d: "Supply, allocation, price",         to: "/tokenomics" },
                    { k: "Contact",     d: "support@aegisonenetwork.com",       to: "mailto:support@aegisonenetwork.com", ext: true },
                ],
            },
        ],
    },
};

export default function MegaMenu() {
    const [open, setOpen] = useState(null);
    const timerRef = useRef(null);

    const enter = (key) => {
        if (timerRef.current) clearTimeout(timerRef.current);
        setOpen(key);
    };
    const leave = () => {
        timerRef.current = setTimeout(() => setOpen(null), 140);
    };

    useEffect(() => () => timerRef.current && clearTimeout(timerRef.current), []);

    return (
        <div className="hidden xl:flex items-center gap-1 relative">
            {Object.keys(MENUS).map((label) => (
                <div
                    key={label}
                    className="relative"
                    onMouseEnter={() => enter(label)}
                    onMouseLeave={leave}
                >
                    <button
                        data-testid={`mega-${label.toLowerCase()}`}
                        className={`px-3 py-2 rounded-md text-[13.5px] font-medium tracking-tight inline-flex items-center gap-1 transition-colors ${
                            open === label
                                ? "text-[var(--text)] bg-[var(--bg-surface)]"
                                : "text-[var(--text-2)] hover:text-[var(--text)] hover:bg-[var(--bg-surface)]"
                        }`}
                    >
                        {label}
                        <CaretDown
                            size={10}
                            className={`transition-transform ${open === label ? "rotate-180 text-[var(--primary)]" : "text-[var(--text-3)]"}`}
                        />
                    </button>
                </div>
            ))}

            {open && (
                <div
                    onMouseEnter={() => enter(open)}
                    onMouseLeave={leave}
                    data-testid={`mega-panel-${open.toLowerCase()}`}
                    className="mega-panel absolute top-full left-0 mt-2 p-6 z-50 fade-in-up"
                    style={{ width: MENUS[open].width }}
                >
                    <div
                        className="grid gap-x-8 gap-y-4"
                        style={{ gridTemplateColumns: `repeat(${MENUS[open].columns.length}, minmax(0, 1fr))` }}
                    >
                        {MENUS[open].columns.map((col) => (
                            <div key={col.title}>
                                <div className="text-[10.5px] uppercase tracking-[0.14em] font-mono text-[var(--text-3)] mb-3 font-medium">
                                    {col.title}
                                </div>
                                <ul className="space-y-1">
                                    {col.items.map((it) => {
                                        const inner = (
                                            <div className="group -mx-2 px-2 py-2 rounded-md hover:bg-[var(--bg-surface)] transition-colors">
                                                <div className="text-[13.5px] font-medium text-[var(--text)] group-hover:text-[var(--primary)] flex items-center gap-1 transition-colors">
                                                    {it.k}
                                                    {it.ext && (
                                                        <ArrowUpRight
                                                            size={11}
                                                            className="text-[var(--text-4)] group-hover:text-[var(--primary)] transition-colors"
                                                        />
                                                    )}
                                                </div>
                                                <div className="text-[12px] text-[var(--text-3)] leading-tight mt-0.5">
                                                    {it.d}
                                                </div>
                                            </div>
                                        );
                                        return it.ext ? (
                                            <li key={it.k}>
                                                <a
                                                    href={it.to}
                                                    target={it.to.startsWith("http") || it.to.startsWith("mailto") ? "_blank" : undefined}
                                                    rel="noreferrer"
                                                >
                                                    {inner}
                                                </a>
                                            </li>
                                        ) : (
                                            <li key={it.k}>
                                                <Link to={it.to} onClick={() => setOpen(null)}>
                                                    {inner}
                                                </Link>
                                            </li>
                                        );
                                    })}
                                </ul>
                            </div>
                        ))}
                    </div>
                </div>
            )}
        </div>
    );
}
